
export class FilteredCollection<T> {
    
    Collection: T[] = [];
    TotalCount: number = -1;
}

export class Filtration {
    PageCriteria: FilterPagingCriteria = new FilterPagingCriteria();

    SearchCriteria: FilterSearchCriteria[] = [];

    SortCriteria: FilterSortCriteria;

}

export class FilterCriteria {

    PageNumber: number = 0;
    PageSize: number = 10;
    SearchCriteria: FilterSearchCriteria[] = [];
    SortCriteria: FilterSortCriteria;
    PageCriteria: FilterPagingCriteria = new FilterPagingCriteria();
}

export class FilterPagingCriteria {
    PageNumber: number = 0;
    PageSize: number = 10;
}

export class FilterSearchCriteria {

    constructor(
        public Field: string,
        public Operator: Operator,
        public SearchKey: string,
        public RelationOperator?: RelationalLogicalOperator
    ) {

        this.RelationOperator = this.RelationOperator || RelationalLogicalOperator.And;
    }
}

export class FilterSortCriteria {

    Field: string;
    Direction: SortDirection;
}

export enum Operator {
    Equal,
    NotEqual,
    GreaterThan,
    GreaterThanOrEqual,
    LessThan,
    LessThanOrEqual,
    Contains
}

export enum RelationalLogicalOperator {
    And,
    Or
}

export enum SortDirection {
    ASC,
    DESC
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/dataModels/grid-list.ts